import { applicationStatus, clientApplicationType } from '~/constants/directoryList.ts';
import React, { useState } from 'react';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { GridCellParams, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';

export const formatDate = (date?: string | null) => {
  if (!date) return '';
  return date.split('T')[0]?.split('-').reverse().join('.') ?? null;
};

export const getStatus = (status: string) => {
  return applicationStatus.find((s) => s.value === status)?.label || status;
};

export const getApplicationType = (type: string) => {
  return clientApplicationType.find((t) => t.value === type)?.label || type;
};

export const getFilterValue = (value: { value: string | null } | string | null | undefined) =>
  typeof value === 'string' ? value : (value?.value ?? null);

export const selectOperator = (
  value: string,
  InputComponent: React.ComponentType<{
    item: GridFilterItem;
    applyValue: (value: GridFilterItem) => void;
  }>
): GridFilterOperator => ({
  label: 'Обрати',
  value,
  getApplyFilterFn: (filterItem: GridFilterItem) => {
    if (!filterItem.value) return null;
    return (params: GridCellParams) => String(params.value) === String(filterItem.value);
  },
  InputComponent,
});

export const containsOperator = (value: string): GridFilterOperator => ({
  label: '=',
  value,
  getApplyFilterFn: (filterItem: GridFilterItem) => {
    if (!filterItem.value) return null;
    return (params: GridCellParams) =>
      String(params.value).toLowerCase().includes(String(filterItem.value).toLowerCase());
  },
  InputComponent: ({
    item,
    applyValue,
  }: {
    item: GridFilterItem;
    applyValue: (value: GridFilterItem) => void;
  }) => {
    const [inputValue, setInputValue] = useState(item.value || '');

    const handleApply = () => {
      applyValue({ ...item, value: inputValue || null });
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') handleApply();
    };

    return (
      <Box sx={{ minWidth: 150 }}>
        <TextField
          size="medium"
          label="Значення"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          fullWidth
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleApply} edge="end" aria-label="search" color="primary">
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
      </Box>
    );
  },
});
